import request from '../../request'

export default {
  /**
   * 更新任务转状态
   * @param {*} data {taskId, status}
   * @param {*} options
   * @returns
   */
  fetchUpdateTask: (data, options = {}) => request(
    {
      url: '/trafficPerformance/updateTask',
      method: 'post',
      desc: '获取任务列表',
    },
    data,
    options,
  ),
  /**
   * 创建一个插件任务
   * @param {*} data { shopId taskType startDate endDate }
   * @param {*} options
   * @returns
   */
  fetchCreatePluginTask: (data, options = {}) => request(
    {
      url: '/trafficPerformance/createTask',
      method: 'post',
      desc: '创建任务',
    },
    data,
    options,
  ),
  /**
   * 批量创建任务
   * @param {*} data
   * @param {*} options
   * @returns
   */
  async fetchPluginHelperBatchCreateTask(data = {}, options = {}) {
    return request(
      {
        url: '/trafficPerformance/batchCreateTask',
        method: 'post',
        desc: '批量创建任务'
      },
      data,
      options,
    )
  },
}
